import { EPSG_OPTIONS, epsgLabel } from '../../constants/epsg';

interface EpsgSelectProps {
  value: number | null;
  onChange: (code: number | null) => void;
  disabled?: boolean;
  id?: string;
}

// Project coordinate-reference-system picker. Empty = local coordinates. Used in
// project create + edit to record the EPSG of the point clouds' real-world
// coordinate system (informational metadata).
const EpsgSelect = ({ value, onChange, disabled, id }: EpsgSelectProps) => {
  // A stored code the list does not offer (filled from a file's own CRS) must
  // still show as itself, or the next save would read it as "Not set".
  const options = value && !EPSG_OPTIONS.some((o) => o.code === value)
    ? [...EPSG_OPTIONS, { code: value, label: epsgLabel(value) }]
    : EPSG_OPTIONS;
  return (
    <select
      id={id}
      className="input-field"
      value={value ?? ''}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value ? parseInt(e.target.value, 10) : null)}
    >
      <option value="">— Not set (local coordinates) —</option>
      {options.map((o) => (
        <option key={o.code} value={o.code}>{o.label}</option>
      ))}
    </select>
  );
};

export default EpsgSelect;
